<script setup lang="ts">
/**
 * An explanation behind an "i": what a table or chart shows, how a number is worked out.
 * Worth reading once, in the way every time after, so it sits beside the heading it belongs
 * to and opens in a box. The box is put at the end of the page rather than where the button
 * is, so a heading never ends up holding a dialog.
 */
import { ref } from 'vue'
import { useAppStore } from '../store'

defineProps<{ title: string; texts: string[] }>()
const store = useAppStore()
const open = ref(false)
</script>

<template>
  <button type="button" class="infobtn" :aria-label="store.t('moreInfo')" :aria-expanded="open" @click="open = true">i</button>
  <Teleport to="body">
    <div v-if="open" class="modal infotip" role="dialog" aria-modal="true" @click.self="open = false">
      <div class="card">
        <h2>{{ title }}</h2>
        <p v-for="(t, i) in texts.filter(Boolean)" :key="i">{{ t }}</p>
        <div class="cardbuttons">
          <span></span>
          <button class="primary" @click="open = false">{{ store.t('closeInfo') }}</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
